class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    console.log('wishlist-button clicked', this.dataset);
    let event = "remove_from_wishlist"
    const payload = {
        "id": this.dataset.product_id,
        "name": this.dataset.productTitle,
        "brand": "JACK & JONES",
        "category": this.dataset.productCategory,
        "price": this.dataset.productPrice,
        "variant": this.dataset.productVariant
    }

    if(this.dataset.added === "false") {
      event = "add_to_wishlist"
    }

    console.log('event', event);
    console.log('payload', payload);
    Shopify.analytics.publish(event, payload);
  }
}

customElements.define('wishlist-button', WishlistButton);